const initialState = {
  activities: {},
  masteries: {},
  studentTrends: {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_CLASSPROGRESS_STATE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
